// src/index.tsx
import { DataGridNav } from "@table-nav/core";
function useTableNav(options) {
  const nav = new DataGridNav(options);
  return {
    listeners: {
      onKeyDown: (e) => nav.tableKeyDown(e),
      onKeyUp: () => nav.tableKeyUp()
    },
    tableNav: nav
  };
}
export {
  useTableNav
};
//# sourceMappingURL=index.mjs.map